import firebase from "datastore/database";

export default function observeDoc(path, onDoc) {
  return firebase
    .firestore()
    .doc(path)
    .onSnapshot((snap) => {
      if (!snap.exists) {
        onDoc(null);
      } else {
        const doc = { uid: snap.id, ...snap.data() };
        onDoc(doc);
      }
    });
}
